import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../utils/firebase";

// Firebase has to check IndexedDB/localStorage before it knows whether
// someone's already signed in, so this starts as "loading" rather than
// assuming logged-out - treating it as logged-out too early would bounce an
// already-signed-in admin to /login for a split second on every page load.
const useAuthUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return { user, loading };
};

export default useAuthUser;
